import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { packetStatusOptions } from '../_Utils/AppDocuCommon';

const StatusFormatter = ({ value }) => {
  const found = packetStatusOptions.find(opt => opt.name === value);
  if (!found) {
    return <span style={{ color: '#222' }}>{value || ''}</span>;
  }
  const color = found.color;
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }} title={found.comment}>
      <span style={{
        display: 'inline-block',
        width: 14,
        height: 14,
        borderRadius: '50%',
        background: color,
        marginRight: 6,
        border: '1.5px solid #bbb',
      }} />
      <span style={{ position: 'relative', top: 2, fontWeight: 'bold' }}>{value || ''}</span>
    </span>
  );
};

const StatusTypeProvider = props => <DataTypeProvider formatterComponent={StatusFormatter} {...props} />;

export default StatusTypeProvider;
